import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="max-w-3xl mx-auto px-4 py-8">
        <div className="mb-8">
          <Link
            to="/"
            className="inline-flex items-center text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            Back to Home
          </Link>
        </div>

        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 p-6 md:p-8">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-6">
            Privacy Policy
          </h1>

          <div className="prose dark:prose-invert">
            <h2>1. Information We Collect</h2>
            <p>
              We collect the following types of information:
            </p>
            <ul>
              <li>Wallet addresses for authentication</li>
              <li>Chat conversations and interactions with our AI</li>
              <li>Technical information necessary for service operation</li>
            </ul>

            <h2>2. How We Use Information</h2>
            <p>
              Your information is used to:
            </p>
            <ul>
              <li>Provide and improve our AI assistant service</li>
              <li>Authenticate and secure your account</li>
              <li>Maintain conversation history for better assistance</li>
              <li>Analyze and improve our service quality</li>
            </ul>

            <h2>3. Data Storage</h2>
            <p>
              We store your data securely and maintain appropriate safeguards to protect your information. Conversation history is stored locally in your browser and can be cleared at any time.
            </p>

            <h2>4. Blockchain Data</h2>
            <p>
              Please note that blockchain transactions are public by nature. While we protect your private information, blockchain interactions may be visible on the Algorand network.
            </p>

            <h2>5. Third-Party Services</h2>
            <p>
              We integrate with:
            </p>
            <ul>
              <li>Algorand blockchain and related services</li>
              <li>Wallet providers for authentication</li>
              <li>GoPlausible services for profile management</li>
            </ul>

            <h2>6. Your Rights</h2>
            <p>
              You have the right to:
            </p>
            <ul>
              <li>Access your personal data</li>
              <li>Request deletion of your data</li>
              <li>Export your conversation history</li>
              <li>Opt out of certain data collection</li>
            </ul>

            <h2>7. Data Retention</h2>
            <p>
              We retain your data only as long as necessary to provide our service or as required by law. You can request deletion of your data at any time.
            </p>

            <h2>8. Updates to Privacy Policy</h2>
            <p>
              We may update this policy periodically. Significant changes will be notified to users.
            </p>

            <h2>9. Contact Us</h2>
            <p>
              For privacy-related questions, please contact us through{' '}
              <a 
                href="https://goplausible.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 dark:text-blue-400 hover:underline"
              >
                goplausible.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};